import { combineReducers } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import categoryReducer from "./categorySlice";
import uiReducer from "./uiSlice";
import shopReducer from "./shopSlice";
import productReducer from "./productSlice";
import orderReducer from "./orderSlice";
import comboReducer from "./comboSlice";

const rootReducer = combineReducers({
    cart: cartReducer,
    category: categoryReducer,
    ui: uiReducer,
    shop: shopReducer,
    product: productReducer,
    order: orderReducer,
    combo: comboReducer
})
export default rootReducer;